function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "View_Disable",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.739792597
}, React.createElement("g", {
  id: "View",
  transform: "translate(4.000000, -1.500000)"
}), React.createElement("g", {
  id: "View-Copy",
  transform: "translate(2.000000, 0.000000)"
}, React.createElement("path", {
  d: "M18.1574796,7.16431577 C17.9954562,6.95340285 14.1349853,2 9.20446575,2 C4.27394625,2 0.413298219,6.95340285 0.251451953,7.16411352 C0.0980008642,7.36420606 0.0980008642,7.63559169 0.251451953,7.83568423 C0.413298219,8.04659715 4.27394625,13 9.20446575,13 C14.1349853,13 17.9954562,8.04656344 18.1574796,7.83585277 C18.3111432,7.63579394 18.3111432,7.36420606 18.1574796,7.16431577 Z M9.20446575,11.8620748 C5.57261287,11.8620748 2.42704267,8.57440191 1.49588644,7.49961235 C2.42583829,6.42387897 5.56481988,3.13792522 9.20446575,3.13792522 C12.8361415,3.13792522 15.9814992,6.42502505 16.9130451,7.50038765 C15.9830932,8.57608732 12.8441116,11.8620748 9.20446575,11.8620748 Z",
  id: "Shape",
  fill: "#8B8B8B",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M9.37603325,4 C7.51452302,4 6,5.48386466 6,7.3076925 C6,9.13152034 7.51452302,10.615385 9.37603325,10.615385 C11.2375435,10.615385 12.7520665,9.13152034 12.7520665,7.3076925 C12.7520665,5.48386466 11.2375435,4 9.37603325,4 Z M9.37603325,9.51279906 C8.13495976,9.51279906 7.12536664,8.52361039 7.12536664,7.3076925 C7.12536664,6.09177461 8.1349931,5.10258594 9.37603325,5.10258594 C10.6170734,5.10258594 11.6266999,6.09177461 11.6266999,7.3076925 C11.6266999,8.52361039 10.6171067,9.51279906 9.37603325,9.51279906 Z",
  id: "Shape",
  fill: "#8B8B8B",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M15.5882353,1 L2,14",
  id: "Line-2",
  stroke: "#8B8B8B",
  strokeWidth: 2,
  strokeLinecap: "square"
}), React.createElement("path", {
  d: "M18,0 L1,16",
  id: "Line-2-Copy",
  stroke: "#FFFFFF",
  strokeWidth: 1.5,
  strokeLinecap: "square"
})));

var SvgPreviewDisable = function SvgPreviewDisable(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "23px",
    height: "15px",
    viewBox: "0 0 23 15",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPreviewDisable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/preview-disable.42f013c8.svg";
export { ForwardRef as ReactComponent };